/**
 * Hook to access workspace preferences
 * Fetches and caches workspace preferences for the current workspace
 * Automatically refetches when workspace changes
 */

import { useGetWorkspacePreferencesQuery } from '@/lib/graphql/types-and-hooks';
import { useWorkspaceId } from './use-workspace-id';

export const useWorkspacePreferences = () => {
  const workspaceId = useWorkspaceId();

  const { data, loading, error, refetch } = useGetWorkspacePreferencesQuery({
    variables: { workspaceId: workspaceId || '' },
    skip: !workspaceId,
  });

  return {
    workspacePreferences: data?.workspacePreferences || null,
    loading,
    error,
    refetch,
  };
};
